import { StrictMode } from 'react';
import { Provider as ReduxProvider } from 'react-redux';

import { CssBaseline, StyledEngineProvider, ThemeProvider } from '@mui/material';
import { SageHomeTheme } from '@sage/ui-components';

import App from './App';
import { SnackbarProvider } from './contexts/SnackbarContext';
import store from './store/store';
import './utils/datadog';
import { createRoot } from 'react-dom/client';

import './index.css';

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const rootElement = document.getElementById('root')!;
if (!rootElement.innerHTML) {
    const root = createRoot(rootElement);
    root.render(
        <StrictMode>
            <ReduxProvider store={store}>
                <CssBaseline>
                    <StyledEngineProvider injectFirst>
                        <ThemeProvider theme={SageHomeTheme}>
                            <SnackbarProvider>
                                <App />
                            </SnackbarProvider>
                        </ThemeProvider>
                    </StyledEngineProvider>
                </CssBaseline>
            </ReduxProvider>
        </StrictMode>
    );
}
